// extracted by mini-css-extract-plugin
export default {"-large":"r5BYtMquFFImbCH7bwzh","divider":"OjnW9hVjHtix3p_1wd85"};